<video-call
  #videocall
  *ngIf="started"
  dev="false"
  (onMessage)="onModuleMessage($event.detail.msg)"
></video-call>
